import React, { ReactNode, useContext, useState } from "react"
import { useAppContext, initialState } from "../../helpers/appContext"
import {
  StyledOverlay,
  StyledContainer,
  StyledContainerClose,
  StyledBG,
  StyledClose,
  StyledIFrame,
  StyledModal,
  StyledModalInfo,
  StyledModalLogo,
  StyledModalTitle,
  StyledModalDescription,
  StyledModalImage,
  StyledModalContent,
  StyledModalForm,
  StyledModalFormTitle,
  StyledInstagramPost,
  StyledInfoWrapper,
  StyledReviewsWrapper,
  StyledTimestamp,
  StyledReviews,
  StyledReview,
  StyledCaption,
  StyledUsername,
  StyledImage,
  StyledComment,
  StyledVideo,
  StyledInfo,
  StyledSlider,
  StyledMedia,
} from "./partials"
import Components from "../index"
import IconV2 from "../icon-v2"
import logo from "../../assets/images/logos/hult-logo-black.svg"
import { unified } from "unified"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import rehypeReact from "rehype-react"
import remarkReactComponents from "../../helpers/remarkReactComponents"
import YouTube, { YouTubeProps } from "react-youtube"
import ButtonV2 from "../button-v2"
import { Swiper, SwiperSlide } from "swiper/react"
import { Pagination, Navigation } from "swiper"

import "swiper/css"
import "swiper/css/pagination"
import "swiper/css/navigation"

const OverlayCmp: React.FC = ({}) => {
  function resetSettings() {
    dispatch({
      type: "MODAL",
      payload: {
        overlay_open: false,
        overlay_video_url: "",
        overlay_modal_title: "",
        overlay_modal_description: "",
        overlay_modal_brochure_image: "",
        overlay_modal_form: "",
        overlay_modal_form_title: "",
      },
    })
    document && document.body.classList.remove("g--no-scroll-v2")
  }

  const { state, dispatch } = useAppContext()

  const onPlayerReady: YouTubeProps["onReady"] = (event) => {
    // event.target.mute();
    event.target.playVideo()
  }

  function date(post) {
    var today = new Date()
    var createdOn = new Date(post)
    var msInDay = 24 * 60 * 60 * 1000

    createdOn.setHours(0, 0, 0, 0)
    today.setHours(0, 0, 0, 0)

    var diff = (+today - +createdOn) / msInDay
    return diff
  }

  if (state.overlay_open) {
    return (
      <>
        <StyledOverlay
          data-name="modal"
          center={state.overlay_video_url ? true : false}
        >
          <StyledBG onClick={() => resetSettings()} />
          <StyledClose onClick={() => resetSettings()}>
            <IconV2 icon="times" iconType="fal" />
          </StyledClose>
          <StyledContainer>
          {
            (state.overlay_modal_title ||
                state.overlay_modal_description ||
                state.overlay_modal_brochure_image ||
                (state.overlay_modal_form && state.overlay_modal_form.length > 0) ||
                state.overlay_modal_form_title) && (
                <StyledModal split={state.overlay_modal_split}>
                  <StyledModalInfo split={state.overlay_modal_split}>
                    <StyledModalLogo alt="Hult" src={logo} />
                    {state.overlay_modal_title && (
                      <StyledModalTitle>
                        {state.overlay_modal_title}
                      </StyledModalTitle>
                    )}
                    {(state.overlay_modal_description ||
                      state.overlay_modal_brochure_image) && (
                      <StyledModalContent>
                        <StyledModalDescription>
                          {
                            unified()
                              .use(remarkParse)
                              .use(remarkRehype)
                              .use(rehypeReact as any, {
                                createElement: React.createElement,
                                components: remarkReactComponents,
                                Fragment: React.Fragment
                              })
                              .processSync(state.overlay_modal_description).result as ReactNode
                          }
                        </StyledModalDescription>
                        {state.overlay_modal_brochure_image && (
                          <StyledModalImage
                            alt="modal-image"
                            src={state.overlay_modal_brochure_image}
                          />
                        )}
                      </StyledModalContent>
                    )}
                  </StyledModalInfo>
                  {state.overlay_modal_form && (
                    <StyledModalForm split={state.overlay_modal_split}>
                      {state.overlay_modal_form_title && (
                        <StyledModalFormTitle split={state.overlay_modal_split}>
                          {state.overlay_modal_form_title}
                        </StyledModalFormTitle>
                      )}
                      {state.overlay_modal_form.map((i) =>
                        React.createElement(Components(i.component), {
                          key: i._uid,
                          blok: i,
                          isDark: true,
                        })
                      )}
                    </StyledModalForm>
                  )}
                </StyledModal>
              )}
            {state.overlay_video_url && (
              <StyledIFrame data-name="modal-video">
                <YouTube
                  videoId={state.overlay_video_url.substr(-11)}
                  onReady={onPlayerReady}
                />
              </StyledIFrame>
            )}
            {state.instagram_post && (
              <StyledInstagramPost>
                <StyledMedia>
                  {state.instagram_video ? (
                    <StyledVideo autoPlay controls>
                      <source src={state.instagram_video} />
                    </StyledVideo>
                  ) : (
                    <>
                      {state.instagram_images.length > 0 ? (
                        <StyledSlider>
                          <Swiper
                            slidesPerView={1}
                            navigation={true}
                            pagination={true}
                            modules={[Pagination, Navigation]}
                          >
                            {state.instagram_images.map((img) => (
                              <SwiperSlide>
                                <StyledImage src={img.url} />
                              </SwiperSlide>
                            ))}
                          </Swiper>
                        </StyledSlider>
                      ) : (
                        <StyledImage src={state.instagram_image} />
                      )}
                    </>
                  )}
                </StyledMedia>
                <StyledInfoWrapper>
                  <StyledCaption>
                    <StyledUsername>
                      <IconV2 icon="instagram" iconType="fab" size="14" />
                      hultbusinessschool
                    </StyledUsername>
                    {state.instagram_text}
                  </StyledCaption>
                  <StyledReviewsWrapper>
                    <ButtonV2
                      link={state.instagram_url}
                      label={"Go to original post"}
                      className="button-v2--secondary"
                    />
                    <StyledInfo>
                      <StyledTimestamp>
                        {date(state.instagram_timestamp.split("T")[0]) > 1 &&
                          `${date(
                            state.instagram_timestamp.split("T")[0]
                          )} days ago`}
                        {date(state.instagram_timestamp.split("T")[0]) === 1 &&
                          `${date(
                            state.instagram_timestamp.split("T")[0]
                          )} day ago`}
                        {date(state.instagram_timestamp.split("T")[0]) === 0 &&
                          `Posted today`}
                      </StyledTimestamp>
                      <StyledReviews>
                        <StyledReview>
                          <IconV2 icon="heart" iconType="fas" size="12" />
                          <p>{state.instagram_like}</p>
                        </StyledReview>
                        <StyledReview>
                          {state.instagram_comment > 0 && (
                            <StyledComment>
                              <IconV2 icon="comment" iconType="fas" size="12" />
                              <p>{state.instagram_comment}</p>
                            </StyledComment>
                          )}
                        </StyledReview>
                      </StyledReviews>
                    </StyledInfo>
                  </StyledReviewsWrapper>
                </StyledInfoWrapper>
              </StyledInstagramPost>
            )}
            <StyledContainerClose onClick={() => resetSettings()} />
          </StyledContainer>
        </StyledOverlay>
      </>
    )
  }
  return null
}

export default OverlayCmp
